import axios from 'axios'
import API from '@s/API'
import Vue from 'vue'
import _forEach from 'lodash/forEach'

const state = {
    groups: [],

}

const getters = {
    groups: state => {
        return state.groups;
    },



}

const mutations = {
    groups(state,payload){
        state.groups = payload
    },

    clearGroups(state){
        state.groups = []
    },


}

const actions = {
    fetchGroups (context,payload) {
        return axios.get(API.route(API.endpoints.groups.index,{universe: payload}))
            .then(response => {
                let groups = response.data;

                _forEach(groups, value => {
                    Vue.set(value,'selected',false)
                })

                context.commit('groups',groups)
            })
    }
}

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;


// WEBPACK FOOTER //
// ./src/stores/modules/groups/store.js